@if (isFilterSupported()) {
  <div class="flex flex-col gap-3"
       [formGroup]="filterForm"
  >
    <p-iconfield>
      <input aria-label="Filter Input"
             class="w-full"
             formControlName="q"
             id="filterInput"
             pInputText
             placeholder="Search"
      />
      <p-inputicon class="pi pi-search"/>
    </p-iconfield>

    @if (contentType() === sidebarContentType.CONTENT_UNITS) {
      <p-autocomplete
        fluid
        formControlName="tags"
        placeholder="Tags"
        [multiple]="true"
        [suggestions]="suggestedTags()"
        (completeMethod)="onTagsSearch($event)"
      />

      <div class="flex items-center gap-2">
        <p-toggleswitch formControlName="includeContent"
                        id="includeContent"
        />
        <label class="text-sm"
               for="includeContent"
        >
          Include Content in Search</label>
      </div>
    }
    <button pButton
            type="button"
            severity="secondary"
            [outlined]="true"
            (click)="reset()"
    >
      Reset
    </button>
  </div>
} @else {
  <div class="text-sm text-gray-500 italic p-2">
    Filtering is currently not supported for this view.
  </div>
}
